module.exports = __webpack_public_path__ + "static/repository-open-graph-cd6185c5617cf401263eac0d96a2419f.png";